export const LENS_ENDPOINT = {
  Mainnet: "https://api.lens.xyz/graphql",
  Staging: "https://api.staging.lens.xyz/graphql",
  Testnet: "https://api.testnet.lens.xyz/graphql"
} as const;
